import { render } from "./AccessDeniedPage.vue?vue&type=template&id=e4175e18"
import script from "./AccessDeniedPage.vue?vue&type=script&lang=js"
export * from "./AccessDeniedPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/likvio.se/html/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__